<script>
import PageHeader from '../../SettingsSubPageHeader.vue';
import BandwidthSms from './BandwidthSms.vue';
import Twilio from './Twilio.vue';
import KavenegarSms from './KavenegarSms.vue';

export default {
  components: {
    PageHeader,
    Twilio,
    BandwidthSms,
    KavenegarSms,
  },
  data() {
    return {
      provider: 'twilio',
    };
  },
};
</script>

<template>
  <div class="h-full w-full p-6 col-span-6">
    <PageHeader
      :header-title="$t('INBOX_MGMT.ADD.SMS.TITLE')"
      :header-content="$t('INBOX_MGMT.ADD.SMS.DESC')"
    />
    <div class="flex-shrink-0 flex-grow-0">
      <label>
        {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.LABEL') }}
        <select v-model="provider">
          <option value="kavenegar">
            {{ $t('INBOX_MGMT.ADD.SMS.PROVIDERS.KAVENEGAR') }}
          </option>
        </select>
      </label>
    </div>
    <Twilio v-if="provider === 'twilio'" type="sms" />
    <KavenegarSms v-else-if="provider === 'kavenegar'" />
    <BandwidthSms v-else />
  </div>
</template>
